import './pens-create-offer-dialog.scss';
import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { CreatePenOfferDto } from 'models/pen/PenOffers';
import { ToastService } from 'services';
import { ErrorService } from 'services/error-service';
import { PenOfferService } from 'services/pen/pen-offer-service';
import { StandardValidationBuilder } from 'lib/validation';
import { ValidationController } from 'aurelia-validation';
import { PenDesignTypeDto } from 'models/pen/PenDesignType';
import { PenDesignTypeService } from 'services/pen/pen-design-type-service';

@autoinject
export class PensCreateOfferDialog {
  private penOffer: CreatePenOfferDto = new CreatePenOfferDto();
  private designTypes: Array<PenDesignTypeDto>;
  private dialogOpen = false;

  constructor(
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private penOfferService: PenOfferService,
    private router: Router,
    private t: I18N,
    private toastService: ToastService,
    private ruleBuilder: StandardValidationBuilder,
    private validationController: ValidationController,
    private penDesignTypeService: PenDesignTypeService
  ) {}

  async attached() {
    try {
      this.eventAggregator.subscribe('PensCreateOfferDialogOpen', (bool) => {
        bool ? this.openDialog() : this.closeDialog();
      });
      const designTypes = await this.penDesignTypeService.getAll();
      //Filter out the other desingtype since we add in manually in the html
      const filterDesignTypes = designTypes.filter((x) => x.Id !== 3);
      this.designTypes = filterDesignTypes;
      this.createValidationRules();
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  private async createOffer() {
    if (!this.penOffer.PenDesignTypeId) {
      this.toastService.showError(this.t.tr('pen.selectPenDesign'));
      return;
    }

    const { valid } = await this.validationController.validate();
    if (!valid) return;

    const { data } = await this.penOfferService.createOffer(this.penOffer);

    this.toastService.showSuccess(this.t.tr('general.created'));
    this.router.navigateToRoute('pen-offer-edit', { Id: data.PenOfferId, PenId: data.PenId });
    this.closeDialog();
  }

  openDialog() {
    this.dialogOpen = true;
    document.querySelector('html').style.overflowY = 'hidden';
  }

  closeDialog() {
    this.dialogOpen = false;
    document.querySelector('html').style.overflowY = null;
  }

  public setCustomer(event) {
    this.penOffer.CustomerId = event.detail.value;
  }

  public getDesignTypeIcon(code) {
    if (code) {
      return require('../../../images/designTypes/' + code + '.svg');
    } else {
      return require('../../../images/designTypes/MISSING.svg');
    }
  }

  private createValidationRules() {
    this.ruleBuilder.with(this.penOffer).required('QuoteNumber').required('CustomerId').required('NumberOfPens').done();
  }
}
